import React from 'react';

const Text = ({ children, variant = 'body', as = 'p', className = '', ...props }) => {
  const Component = as;

  const variantClasses = {
    heading:       'text-4xl font-bold tracking-tight',
    title:         'text-xl font-semibold',
    subtitle:      'text-lg font-medium',
    body:          'text-sm leading-relaxed',
    bodySmall:     'text-xs leading-relaxed',
    caption:       'text-xs font-medium',
    link:          'text-sm hover:underline inline-block cursor-pointer',
    'text-primary':   'text-base',
    'text-secondary': 'text-sm font-medium',
    captionNeutral:   'text-xs font-medium',
  };

  // Color is now driven by CSS vars, not hardcoded Tailwind colours
  const variantColors = {
    heading:          'var(--text-primary)',
    title:            'var(--text-primary)',
    subtitle:         'var(--text-secondary)',
    body:             'var(--text-body)',
    bodySmall:        'var(--text-body)',
    caption:          'var(--text-muted)',
    link:             'var(--brand)',
    'text-primary':   'var(--text-primary)',
    'text-secondary': 'var(--text-muted)',
    captionNeutral:   'var(--text-muted)',
  };

  return (
    <Component
      className={`${variantClasses[variant] ?? variantClasses.body} ${className}`}
      style={{ color: variantColors[variant] }}
      {...props}
    >
      {children}
    </Component>
  );
};

export default Text;
